module.exports = __webpack_public_path__ + "static/img/C4D0033.a85de50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0033.jpg
// module id = xE3Z
// module chunks = 0